import { Skeleton } from "@/components/ui/skeleton";

/**
 * O que aparece enquanto o código da tela ainda está baixando.
 *
 * Cada rota é um chunk separado (`autoCodeSplitting`), então a primeira
 * visita a uma tela espera um download antes de existir qualquer componente
 * pra renderizar. Sem isto o router não desenha nada nesse intervalo: a tela
 * ANTERIOR fica parada, sem esqueleto e sem spinner, e a impressão é de
 * travamento — o clique não produziu reação nenhuma.
 */
export function RoutePending() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-4 p-4 sm:p-6">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
